import React from "react";
import { Pencil, Trash2, Upload } from "lucide-react";
import { useTranslation } from "react-i18next";
import ListItemCardCst from "@components/ListItemCardCst";
import { formatActivityTypeLabel } from "../AddActivity/config/activityTypes";
import { DraftListItem, draftEntityType } from "../types";
import { ENTITY_ICON } from "../entityIcons";

interface DraftItemProps {
  draft: DraftListItem;
  badgeLabel: string;
  editLabel: string;
  promoteLabel: string;
  deleteLabel: string;
  onEdit: (draft: DraftListItem) => void;
  onPromote: (draft: DraftListItem) => void;
  onDelete: (draft: DraftListItem) => void;
  actionsDisabled?: boolean;
}

const DraftItem: React.FC<DraftItemProps> = ({
  draft,
  badgeLabel,
  editLabel,
  promoteLabel,
  deleteLabel,
  onEdit,
  onPromote,
  onDelete,
  actionsDisabled,
}) => {
  const { t: tActivity } = useTranslation("wizard-activity");
  const { t } = useTranslation("catalog-v2");
  const type = draftEntityType(draft);
  const wizard = draft.data?.__draft?.wizard;
  const title = wizard?.title || draft.title || `#${draft.id}`;

  const activityType =
    type === "activity"
      ? formatActivityTypeLabel(draft.lo_type, tActivity)
      : type === "course"
        ? String(t("type-labels.course-default"))
        : String(t("type-labels.path-default"));

  const code = wizard?.digited_code ? String(wizard.digited_code) : undefined;

  return (
    <ListItemCardCst
      icon={ENTITY_ICON[type]}
      title={title}
      subtitle={{ id: draft.id, code, activityType }}
      badges={[{ label: badgeLabel, variant: "warning" }]}
      moreActions={[
        [
          {
            label: editLabel,
            icon: <Pencil size={16} />,
            onClick: () => onEdit(draft),
            disabled: actionsDisabled,
          },
          {
            label: promoteLabel,
            icon: <Upload size={16} />,
            onClick: () => onPromote(draft),
            disabled: actionsDisabled,
          },
          {
            label: deleteLabel,
            icon: <Trash2 size={16} />,
            onClick: () => onDelete(draft),
            disabled: actionsDisabled,
          },
        ],
      ]}
    />
  );
};

export default DraftItem;
